import React from "react"
import { motion } from 'framer-motion'
import logo from '../../Assets/Images/logo.png'
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

const Footer = () => {
    const history = useHistory()
    const { t } = useTranslation()

    return (
        <motion.div className="flex flex-col relative w-full">
            {/* Top Section */}
            <motion.div className="bg-orangeColor px-6 md:px-20 py-10 w-full">
                <motion.div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 items-start">
                    {/* Logo */}
                    <motion.div className="flex justify-center md:justify-start">
                        <img src={logo} alt="logo" className="w-40 md:w-52 h-auto" />
                    </motion.div>

                    {/* Navigation 1 */}
                    <motion.div className="flex flex-col gap-5 items-center md:items-start">
                        <p className="text-white text-lg md:text-xl font-bold hover:text-primeColor cursor-pointer" onClick={() => history.push('/')}>
                            {t('Home')}
                        </p>
                        <p className="text-white text-lg md:text-xl font-bold hover:text-primeColor cursor-pointer" onClick={() => history.push('/aboutUs')}>
                            {t('About Us')}
                        </p>
                        <p className="text-white text-lg md:text-xl font-bold hover:text-primeColor cursor-pointer" onClick={() => history.push('/contactUs')}>
                            {t('Contact Us')}
                        </p>
                    </motion.div>

                    {/* Navigation 2 */}
                    <motion.div className="flex flex-col gap-5 items-center md:items-start">
                        <p className="text-white text-lg md:text-xl font-bold hover:text-primeColor cursor-pointer" onClick={() => history.push('/pricing')}>
                            {t('Pricing')}
                        </p>
                        <p className="text-white text-lg md:text-xl font-bold hover:text-primeColor cursor-pointer" onClick={() => history.push('/auth/login')}>
                            {t('Login')}
                        </p>
                        <p className="text-white text-lg md:text-xl font-bold hover:text-primeColor cursor-pointer" onClick={() => history.push('/auth/register')}>
                            {t('Signup')}
                        </p>
                    </motion.div>
                </motion.div>
            </motion.div>

            {/* Bottom Section */}
            <motion.div className="bg-primeColor/20 py-6 px-6 md:px-20 text-center text-sm md:text-lg font-bold flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4">
                <span>© 2025 Royal Kavery Matrimony | Developed & Maintained by</span>
                <a
                    href="https://solvintel.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primeColor text-base md:text-xl font-bold hover:underline"
                >
                    Solvintel
                </a>
            </motion.div>
        </motion.div>
    )
}

export default Footer